import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSpotifyStyle0 = cosmosIconCss;

const CosmosIconSpotify$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSpotify extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0fb4f74cc72a5a2aef3599d91bd8e608a276148c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd94b9116f95f15f1f547bb9f38bb73f77f4fdedd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '58fb59f9a7a28677a1589f990e32e8bc6fa973f9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.324 9.979C13.423 8.256 8.637 8.097 5.868 8.938a.842.842 0 1 1-.489-1.611c3.18-.965 8.464-.779 11.804 1.204a.842.842 0 0 1-.86 1.448Zm-.095 2.552a.702.702 0 0 1-.965.23c-2.419-1.486-6.107-1.917-8.969-1.048a.703.703 0 0 1-.407-1.343c3.268-.992 7.332-.511 10.11 1.196a.7.7 0 0 1 .23.964Zm-1.101 2.45a.56.56 0 0 1-.772.187c-2.113-1.292-4.773-1.583-7.906-.868a.56.56 0 1 1-.25-1.093c3.428-.784 6.37-.447 8.741 1.003a.561.561 0 0 1 .187.771ZM11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSpotifyStyle0; }
}, [1, "cosmos-icon-spotify", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-spotify"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-spotify":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSpotify$1);
            }
            break;
    } });
}

const CosmosIconSpotify = CosmosIconSpotify$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSpotify, defineCustomElement };
